import { render } from "./TheInputRadio.vue?vue&type=template&id=22065a2b"
import script from "./TheInputRadio.vue?vue&type=script&lang=js"
export * from "./TheInputRadio.vue?vue&type=script&lang=js"

import "./TheInputRadio.vue?vue&type=style&index=0&id=22065a2b&lang=css"

import exportComponent from "F:\\Softwaresul\\Projetos\\LWP\\Nil Recruiter\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__